module.exports = __webpack_public_path__ + "static/media/dark-theme-adblue-zone.e56d8ea4.svg";